"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getRole = function (data) {
    if (data.is_admin || data.role === 'admin')
        return 'admin';
    if (data.role === 'superadmin')
        return 'superAdmin';
    if (data.role === 'manager')
        return 'manager';
    return 'user';
};
exports.default = getRole;
